// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___3pErS","labelOff":"styles__labelOff___dpNJt styles__label___3pErS","container":"styles__container___1qn4O","value":"styles__value___3c629"};